import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Iconify from 'src/components/iconify';
import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function HomeContactCTA() {
  const renderContent = (
    <m.div variants={varFade().in}>
      <Box
        sx={{
          textAlign: 'center',
          mt: { xs: 5, md: 10 },
          maxWidth: 640,
          mx: 'auto',
        }}
      >
        <m.div variants={varFade().inDown}>
          <Typography variant="h4">Want to Discuss Something?</Typography>
        </m.div>

        <m.div variants={varFade().inDown}>
          <Typography
            sx={{
              mt: 2,
              mb: 5,
              color: 'text.secondary',
            }}
          >
            If you have a question, idea, or simply want to talk about frontend architecture,
            performance, or product development, feel free to reach out. I’m always open to
            thoughtful conversations.
          </Typography>
        </m.div>

        <m.div variants={varFade().inUp}>
          <Button
            startIcon={<Iconify icon="fluent:mail-20-filled" width={20} />}
            color="inherit"
            size="medium"
            variant="contained"
            target="_blank"
            rel="noopener noreferrer"
            href="https://mail.google.com/mail?view=cm&tf=0&to=satyendrasr.career@gmail.com&subject=Hello%20Satyendra&body="
          >
            Start a Conversation
          </Button>
        </m.div>
      </Box>
    </m.div>
  );

  return (
    <Box
      sx={{
        py: { xs: 5, md: 10 },
        bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
      }}
    >
      <Container component={MotionViewport}>{renderContent}</Container>
    </Box>
  );
}
